import * as React from 'react';
const classNames = require('classnames');

import Utils from '../common/utils';
import { Button } from '../components/buttons';

interface Props {
	wrapperClassName?: string;
	buttonClassName?: string;
	steps: Array<any>;
	activeStep: number;
	maxStepIndex?: number;
}
interface State {
	maxStepIndex: number;
}
class WorkflowProgress extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			maxStepIndex: 0
		};
	}

	componentDidMount() {
		this.setState({
			maxStepIndex: this.props.maxStepIndex || this.props.activeStep
		});
		Utils.setDocTitle(this.props.steps[this.props.activeStep].label);
	}

	componentWillReceiveProps(nextProps: Props) {
		if (nextProps.activeStep > this.state.maxStepIndex) {
			this.setState({
				maxStepIndex: nextProps.activeStep
			});
		}

		if (nextProps.activeStep !== this.props.activeStep) {
			Utils.setDocTitle(nextProps.steps[nextProps.activeStep].label);
		}
	}

	render() {
		const { wrapperClassName, buttonClassName, steps, activeStep } = this.props;
		return (
			<div className={classNames('workflow-progress', wrapperClassName)}>
				{steps.map((step: any, index: number) => (
					<div
						className={classNames('workflow-progress-item', {
							active: index === activeStep,
							disabled: step.incomplete || index > this.state.maxStepIndex
						})}
						key={index}
					>
						<Button
							onClick={step.onClick}
							to={step.to}
							tabIndex={step.incomplete || index > this.state.maxStepIndex ? -1 : undefined}
							
							className={classNames('workflow-progress-link', buttonClassName, {
								active: index === activeStep,
								disabled: step.incomplete || index > this.state.maxStepIndex,
								'disable-click': step.disableClick
							})}
						>
							<span className="mx-1 d-inline-block d-lg-none font-weight-normal">
								Step {index + 1} of {steps.length}:
							</span>
							<span className="mx-1 d-inline-block">{step.label}</span>
						</Button>
					</div>
				))}
			</div>
		);
	}
}

export default WorkflowProgress;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/WorkflowProgress.tsx